import React, { useEffect, useState } from 'react';
import './AdminLangCapt.scss'
import { getCurrentSubTab } from '../../../redux/actions/adminSideMenuAction';
import { useDispatch, useSelector } from 'react-redux';
import Helmet from 'react-helmet'
import { database } from '../../../utils/firebase';
import Some from './some';
import LangCaptComponent from './LangCaptComponent';

const AdminLangCapt = () => {
    const [allLive, setAllLive] = useState(true)
    const [languageData, setLanguageData] = useState([])
    
    const dispatch = useDispatch()
    const [loaded, setLoaded] = useState(false)
    const [langId, setLangId] = useState('');
    const [checkGoLive, setCheckGoLive] = useState(false);
    const [ss, setss] = useState([]);
    const savedCaption = useSelector(state => state.savedCaption)
    const {caption} =savedCaption
    const [lang, setLang] = useState([])

    useEffect(() => {
        if (languageData.every(el => el.live === true)) {
            setAllLive(true)
        } else {
            setAllLive(false)
        }
    }, [allLive, languageData])

    

    useEffect(() => {
        dispatch(getCurrentSubTab('s2text'))
    }, [dispatch])

    useEffect(() => {
        if(caption.length > 1) {
            setLang(caption)
            setLoaded(true)            
        }
    }, [caption, caption.length]);

    useEffect(() => {
       const langRef = database.ref('Languages')
       langRef.on('value', (el) => {
        let eData = []
        for (let id in el.val()) {
            eData.push({id, ...el.val()[id]})
        }
        setLanguageData(eData)
        
       })

    }, []);

    // useEffect(() => {
    //     if(languageData.length > 0) {
    //         let eData = []
    //         languageData.map(el => {
    //             const lan = el.language
    //             const enRef = database.ref(el.langCode)
    //             enRef.on('value', (el) => {    
    //                 for (let id in el.val()) {
    //                     eData.push({id, language: lan, ...el.val()[id]})
                       
    //                 } 
    //             })
    //         })
          
    //             setLang(eData)
    //             setLoaded(true)
    //     } 

       

    //             const enRef = database.ref('en')
    //             enRef.on('value', (el) => {   
    //                 let eData = [] 
    //                 for (let id in el.val()) {
    //                     eData.push({id, language: el.val().language, ...el.val()[id]})
                       
    //                 } 

    //                 setss(eData)
    //             })

    // }, [languageData])

    useEffect(() => {
        if(checkGoLive) {
            const langRef = database.ref('Languages').child(langId)
            langRef.update({
                live: true
            })

            setLangId('')
            setCheckGoLive(false)
        }
    }, [checkGoLive, langId])

    const handleGoLiveAll = () => {
        languageData.forEach(el => {
            const langRef = database.ref('Languages').child(el.id)
            langRef.update({
                live: true
            })
        })
    }

    const handleAllLive = () => {
        languageData.forEach(el => {
            const langRef = database.ref('Languages').child(el.id)
            langRef.update({
                live: false
            })
        })
    }



    return (
        <div className="admin-lang-capt">
        
            
            <Helmet htmlAttributes>
                    <meta charSet="utf-8" />
                    <html lang="en" />
                    <title>Admin-Text | LVZConnect</title>
                    <meta name="description" content="LVZConnect Admin Text Page" />
            </Helmet>
            <div className="top">
                <h2>Language Caption</h2>
                {allLive? <button className="all-live" onClick={handleAllLive}>LIVE</button> : <button onClick={handleGoLiveAll}>GO LIVE ALL</button>}
                
            </div>

            <div className="lang-capt-view">
               
                

                {languageData.map(el => {
                    
                    return (
                        <LangCaptComponent language={el.language} live={el.live} langId={el.id} langCode={el.langCode} key={el.id}/>
                        // <div className="lang-capt" key={el.id}>
                        //     <h4>{el.language}</h4>
                        //     <div className="capt-field">
                        //         <div className='container'>
                        //             <div className='speech-to-text'>
                        //                 {loaded? 
                                        
                        //                 lang.map(el1 => {
                        //                     if(el.language === el1.language) {
                        //                         return (
                        //                             <p key={el1.id}>{el1.text}</p>
                        //                         )
                        //                     } 
                        //                 }) : ''}
                        //             </div>
                        //         </div>
                        //         {el.live? <button onClick={() => handleLive(el.id)}>LIVE</button>: <button className='go-live' onClick={() => handleGoLive(el.id)}>GO LIVE</button>}                           
                        //     </div>
                        // </div>
                    )
                })}
                
            </div>
            

        </div>
    )
}

export default AdminLangCapt